import React  from 'react'
import { useDropzone } from 'react-dropzone'
import './index.scss'
import { AttachmentEntity } from '../../../customEntites/Attachment.entity'
import { useTranslation } from 'react-i18next'

export const CustomUplaodInput = ({
  label,
  supportedFileTypes,
  setAttachments
}: {
  label: string,
  supportedFileTypes?: string,
  setAttachments: any
}) => {
  const { t } = useTranslation()
  const acceptedFileTypes = ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf']

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      const filteredFiles: AttachmentEntity[] = []
      for (let i = 0; i < acceptedFiles.length; i++) {
        const file = acceptedFiles[i]
        if (acceptedFileTypes.includes(file.type)) {
          filteredFiles.push({
            file,
            customProperties: {}
          })
        }
      }
      setAttachments((prev: any) => [...prev, ...filteredFiles])
    },
  })

  const handleMultipleAttachments = (event: any) => {
    const selectedFiles: any[] = []
    const targetFiles = event.target.files
    const targetFilesObject = [...targetFiles]
    targetFilesObject.forEach((file) => {
      selectedFiles.push(file)
    })
    setAttachments((prev: any) => [...prev, ...selectedFiles])
    event.target.value = null
  }

  return (
    <div
      className='custom-upload-input'
      {...getRootProps()}
    >
      <label htmlFor='file-upload-input'>
        {label}
      </label>
      <button
        type="button"
        className='upload-file-button'
        aria-label={String(t('REPAIR_AND_INQUIRIES.UPLOAD_ATTACHMENT'))}
      >
        +
      </button>
      <input
        id='file-upload-input'
        {...getInputProps()}
        onChange={handleMultipleAttachments}
        type='file'
        accept={acceptedFileTypes.toString()}
        multiple
        aria-label={String(t('REPAIR_AND_INQUIRIES.FILE_UPLOAD_INPUT'))}
      />
      <label>{supportedFileTypes}</label>
    </div>
  )
}